import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import ReactApexChart from 'react-apexcharts';
import { Sparklines } from 'react-sparklines';
import { SparklinesBars } from 'react-sparklines';
import { apiEndpoint } from "helpers/url_helper";



class YearlySales extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                chart: {
                    toolbar: {
                        show: false,
                    },
                },
                colors: ['#7A6FBE', '#28BBE3'],
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                        dataLabels: {
                            show: false
                        },

                    },
                },
                legend: {
                    show: false
                },
                dataLabels: {
                    enabled: false,
                },
                grid: {
                    show: false,
                    row: {
                        colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    categories: [],
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    tooltip: {
                        enabled: false
                      },
                      dataLabels: {
                        enabled: false,
                    },
                },
                yaxis: {
                    labels: {
                        show: false
                    },
                    tooltip: {
                        enabled: false
                      }
                },
            },
            series: [{
                name: 'Series A',
                data: [8, 6, 4, 7, 10, 12, 7, 4, 9, 12, 13, 11, 12]
            },],
            YearlyCount:''
        }
    }
    async componentDidUpdate(prevProps) {
        if(prevProps.CampusID!=this.props.CampusID){
            var intCampusID=this.props.CampusID;
            // UserValidated
            const url= apiEndpoint+'/GetYearlyViolations';
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
          fetch(url,{ 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "intCampusID": intCampusID,
              "strToken": sessionStorage.getItem("Clear_AuthUser")
            })
          })
          .then(res => res.json()).then((result) =>{  
            //console.log(result)
            this.setState({ YearlyCount: result.TotalViolationsCount })}).catch((error) => console.log(error));
        }}
      UNSAFE_componentWillReceiveProps(props) {
        var intCampusID=props.CampusID;
        // UserValidated
        const url= apiEndpoint+'/GetYearlyViolations';
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
      fetch(url,
        { 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "intCampusID": intCampusID,
              "strToken": sessionStorage.getItem("Clear_AuthUser")
            })
  
       }).then(res => res.json()).then((result) =>{  
        //console.log(result)
        this.setState({ YearlyCount: result.TotalViolationsCount })}).catch((error) => console.log(error));
      }
    render() {
        //console.log(this.state.YearlyCount)
        return (
         
            <React.Fragment>
                <Card>
                    <CardBody>
                        <h4 className="card-title mb-4">Yearly Violations</h4>
                        <Row>
                            <Col md="4">
                                <div>
                                    <h3>{this.state.YearlyCount}</h3>
                                    <p className="text-muted">Total Violations in campus</p>
                       
                                </div>
                            </Col>
                            <Col md="8" className="text-end">
                                <div id="sparkline">

                                <Sparklines
              data={[8, 6, 4, 7, 10, 12, 7, 4, 9, 12, 13, 11, 12]}
              margin={3}
              svgWidth={200}
              svgHeight={100}
            >
              <SparklinesBars
                margin={3}
                style={{
                  strokeWidth: 5,
                  stroke: "#7A6FBE",
                  fill: "#7A6FBE"
                }}
              />
            </Sparklines>
                               
           {/* <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height="130" className="apex-charts" /> */}
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default YearlySales;